<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Financial Report - CASHFLOW(indirect), CHANGE IN EQUITY, etc.  
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error" 
                        v-b-tooltip.hover title="Select CASHFLOW, CHANGE IN EQUITY, etc.  Defined it from Setting Menu ! "></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th width="110px">Src.Code</th>
                            <th width="110px">Src.Field</th>
                            <th >Description</th>
                            <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMM YYYY")}}</th>
                            <th v-else style="text-align:right" width="140px">Month to date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                            <td :class="row.kelas">{{row.kode}}</td>
                            <td :class="row.kelas">{{row.field}}</td>
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillSdAkhir(row)" style="text-align:right">{{row.nilai | numFormat}}</td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import fp from "../../apis/consolidacashflw_indi";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptLines= await fp.layout({layout : newval});
      }
  },
created: async function (){
     this.layouts = await fp.layout_combo();
    var tgl2 = moment(this.$store.state.user.tglaktifconsol, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
    // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    this.filter.tglbulanini= tgl2;
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
        // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tglbulanini= tgl2;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines= await fp.rptcf(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.reportUrl= await fp.rptcfprint(this.filter);
                this.showReport=true;
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await fp.rptcfexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillPrevmonth: function(data){
        if (data.kode) {
            var tgl2 = moment(`${this.filter.tglbulanlalu.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: tgl2.format('YYYY-MM-DD')}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY')}-01-01/${tgl2.format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillSdAkhir: function(data){
        if (data.kode) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY')}-01-01/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillSdAwal: function(data){
        if (data.kode) {
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${this.filter.tgltahunlalu.format('YYYY')}-01-01/${this.filter.tgltahunlalu.format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    close(){
      router.push("home");
    }
  }
};
</script>
